const propertyTypes = [
    { value: "cornercondominium", label: "CORNER CONDOMINIUM" },
    { value: "middlecondominium", label: "MIDDLE CONDOMINIUM" },

    { value: "1storeybungalow", label: "1 STOREY BUNGALOW" },
    { value: "2storeybungalow", label: "2 STOREY BUNGALOW" },
    { value: "3storeybungalow", label: "3 STOREY BUNGALOW" },
    { value: "endlotbungalow", label: "ENDLOT BUNGALOW" },
    { value: "cornerbungalow", label: "CORNER BUNGALOW" },

    { value: "1storeycluster", label: "1 STOREY CLUSTER" },
    { value: "2storeycluster", label: "2 STOREY CLUSTER" },
    { value: "3storeycluster", label: "3 STOREY CLUSTER" },
    { value: "endlotcluster", label: "ENDLOT CLUSTER" },
    { value: "cornercluster", label: "CORNER CLUSTER" },

    { value: "1storeysemid", label: "1 STOREY SEMI-D" },
    { value: "2storeysemid", label: "2 STOREY SEMI-D" },
    { value: "3storeysemid", label: "3 STOREY SEMI-D" },
    { value: "endlotsemid", label: "ENDLOT SEMI-D" },
    { value: "cornersemid", label: "CORNER SEMI-D" },

    { value: "1storeyterrace", label: "1 STOREY TERRACE" },
    { value: "2storeyterrace", label: "2 STOREY TERRACE" },
    { value: "3storeyterrace", label: "3 STOREY TERRACE" },
    { value: "endlotterrace", label: "ENDLOT TERRACE" },
    { value: "cornerterrace", label: "CORNER TERRACE" },

    { value: "1storeylinkedhouse", label: "1 STOREY LINKED HOUSE" },
    { value: "2storeylinkedhouse", label: "2 STOREY LINKED HOUSE" },
    { value: "3storeylinkedhouse", label: "3 STOREY LINKED HOUSE" },
    { value: "endlotlinkedhouse", label: "ENDLOT LINKED HOUSE" },
    { value: "cornerlinkedhouse", label: "CORNER LINKED HOUSE" },

    { value: "1storeysuperlink", label: "1 STOREY SUPERLINK" },
    { value: "2storeysuperlink", label: "2 STOREY SUPERLINK" },
    { value: "3storeysuperlink", label: "3 STOREY SUPERLINK" },
    { value: "endlotsuperlink", label: "ENDLOT SUPERLINK" },
    { value: "cornersuperlink", label: "CORNER SUPERLINK" },

    { value: "1storeyshoplot", label: "1 STOREY SHOPLOT" },
    { value: "2storeyshoplot", label: "2 STOREY SHOPLOT" },
    { value: "3storeyshoplot", label: "3 STOREY SHOPLOT" },
    { value: "endlotsshoplot", label: "ENDLOT SHOPLOT" },
    { value: "cornershoplot", label: "CORNER SHOPLOT" },

    { value: "uppertownhouse", label: "UPPER TOWNHOUSE" },
    { value: "groundtownhouse", label: "GROUND TOWNHOUSE" },
    { value: "endlottownhouse", label: "ENDLOT TOWNHOUSE" },
    { value: "cornertownhouse", label: "CORNER TOWNHOUSE" },

    { value: "cornerflat", label: "CORNER FLAT" },
    { value: "middleflat", label: "MIDDLE FLAT" },

    { value: "cornerapartment", label: "CORNER APARTMENT" },
    { value: "middleapartment", label: "MIDDLE APARTMENT" },

    {
        value: "cornerservicedapartment",
        label: "CORNER SERVICED APARTMENT",
    },
    {
        value: "middleservicedapartment",
        label: "MIDDLE SERVICED APARTMENT",
    },

    { value: "cornerpenthouse", label: "CORNER PENTHOUSE" },
    { value: "middlepenthouse", label: "MIDDLE PENTHOUSE" },

    { value: "cornerduplex", label: "CORNER DUPLEX" },
    { value: "middleduplex", label: "MIDDLE DUPLEX" },

    { value: "cornerloft", label: "CORNER LOFT" },
    { value: "middleloft", label: "MIDDLE LOFT" },

    { value: "cornersoho", label: "CORNER SOHO" },
    { value: "middlesoho", label: "MIDDLE SOHO" },

    { value: "cornersofo", label: "CORNER SOFO" },
    { value: "middlesofo", label: "MIDDLE SOFO" },

    { value: "cornersovo", label: "CORNER SOVO" },
    { value: "middlesovo", label: "MIDDLE SOVO" },

    { value: "cornervos", label: "CORNER VOS" },
    { value: "middlevos", label: "MIDDLE VOS" },

    { value: "cornershophouse", label: "CORNER SHOP HOUSE" },
    { value: "middleshophouse", label: "MIDDLE SHOP HOUSE" },

    { value: "cornerretaillot", label: "CORNER RETAIL LOT" },
    { value: "middleretaillot", label: "MIDDLE RETAIL LOT" },

    { value: "residentialland", label: "RESIDENTIAL LAND" },
    { value: "commercialland", label: "COMMERCIAL LAND" },
    { value: "industrialland", label: "INDUSTRIAL LAND" },
    { value: "agriculturalland", label: "AGRICULTURAL LAND" },
    { value: "publicinstitutionalland", label: "PUBLIC / INSTITUTIONAL LAND" },
    { value: "lowcostterrace", label: "LOW-COST TERRACE" },
];

export default propertyTypes;
